import React from 'react';
import { Box, Typography } from '@mui/material';

export type PreviewFrameProps = {
  label?: string;
  svg?: string | null;
  // Optional direct image src (e.g., https URL to S3/CloudFront). If provided, takes precedence.
  src?: string;
  minHeight?: number;
  // If true, render using <img>; if no src, will fallback to data URL from svg
  // Default true for robustness across browsers
  useImageTag?: boolean;
};

const svgToDataUrl = (svg: string) => {
  try {
    const encoded = encodeURIComponent(svg)
      .replace(/%0A/g, '')
      .replace(/%20/g, ' ');
    return `data:image/svg+xml;utf8,${encoded}`;
  } catch {
    const b64 = btoa(unescape(encodeURIComponent(svg)));
    return `data:image/svg+xml;base64,${b64}`;
  }
};

const PreviewFrame: React.FC<PreviewFrameProps> = ({
  label,
  svg,
  src,
  minHeight = 300,
  useImageTag = true,
}) => {
  const content = svg || '';

  return (
    <Box sx={{ mb: 1 }}>
      {label && (
        <Typography variant="body2" gutterBottom>
          {label}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight,
          bgcolor: 'grey.50',
          borderRadius: 1,
          p: 1,
        }}
      >
        {useImageTag ? (
          <img
            alt={label || 'preview'}
            style={{ maxWidth: '100%', maxHeight: minHeight, width: '100%' }}
            src={src || (svg ? svgToDataUrl(content) : undefined)}
          />
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: content }}
            style={{
              maxWidth: '100%',
              maxHeight: minHeight,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default PreviewFrame;

